/**
 * Home hero copy, TR / EN / DE.
 *
 * `badge`, `titleLead`, `titleTail`, `description`, `ctaPrimary` and
 * `ctaSecondary` are lifted VERBATIM from the former hero of App.jsx,
 * AppEN.jsx and AppDE.jsx (JSX line wraps collapsed to single spaces;
 * `titleTail` was the <span> inside the h1).
 * `imageAlt` reuses the part's caption from src/data/portfolio-captions.js.
 *
 * New strings (facts already published on the site):
 *   service  — the overlay label naming the process that printed the mark
 *   markName — the overlay legend under it
 */
export const HERO_I18N = {
  tr: {
    badge: 'Global OEM Standartlarında Üretim',
    titleLead: 'Otomotiv Trim Parçalarında',
    titleTail: 'Kusursuz Baskı Uygulamaları',
    description:
      'Modern baskı teknolojileri ve uzman proses yönetimiyle; T2 tedarik zincirinin kalite beklentilerini, yüksek hassasiyetli üretim ve ISO 9001:2015 uyumlu süreçlerle karşılıyoruz.',
    ctaPrimary: 'Hemen Teklif Al',
    ctaSecondary: 'İncele',
    imageAlt: 'ISOFIX kapağı',
    service: 'Tampon Baskı',
    markName: 'ISOFIX',
  },
  en: {
    badge: 'Global OEM-Standard Manufacturing',
    titleLead: 'Precision Printing for',
    titleTail: 'Automotive Trim Parts',
    description:
      'Delivering high-precision pad printing, screen printing, and assembly solutions for the automotive industry. ISO 9001:2015 certified processes meeting global T2 supply chain quality standards.',
    ctaPrimary: 'Request a Quote',
    ctaSecondary: 'Explore',
    imageAlt: 'ISOFIX cover',
    service: 'Pad Printing',
    markName: 'ISOFIX',
  },
  de: {
    badge: 'Globale OEM-Standardfertigung',
    titleLead: 'Präzisionsdruck für',
    titleTail: 'Fahrzeuginnenraumteile',
    description:
      'Hochpräziser Tampondruck, Siebdruck und Montagelösungen für die Automobilindustrie. ISO 9001:2015 zertifizierte Prozesse, die globale T2-Lieferkettenstandards erfüllen.',
    ctaPrimary: 'Angebot anfordern',
    ctaSecondary: 'Entdecken',
    imageAlt: 'ISOFIX-Abdeckung',
    service: 'Tampondruck',
    markName: 'ISOFIX',
  },
}
